(function () {
  function init() {
    var ymm = window.fiberwerxYMM;
    if (!ymm) {
      setTimeout(init, 50);
      return;
    }

    var modal = document.getElementById('FitmentModal');
    if (!modal) return;

    var overlay = modal.querySelector('.fitment-modal__overlay');
    var closeBtn = modal.querySelector('.fitment-modal__close');
    var yearSel = document.getElementById('fitment-modal-year');
    var makeSel = document.getElementById('fitment-modal-make');
    var modelSel = document.getElementById('fitment-modal-model');
    var confirmBtn = document.getElementById('fitment-modal-confirm');

    /* ── Populate helpers ── */
    function populate(selectEl, items, placeholder) {
      selectEl.innerHTML = '<option value="">' + placeholder + '</option>';
      items.forEach(function (item) {
        var opt = document.createElement('option');
        opt.value = typeof item === 'object' ? item.key : item;
        opt.textContent = typeof item === 'object' ? item.label : item;
        selectEl.appendChild(opt);
      });
      selectEl.disabled = false;
      selectEl.value = '';
    }

    function reset(selectEl, placeholder) {
      selectEl.innerHTML = '<option value="">' + placeholder + '</option>';
      selectEl.disabled = true;
    }

    /* ── Open / Close ── */
    function open() {
      /* Reset selects each time modal opens */
      populate(yearSel, ymm.getAllYears(), 'Select Year');
      reset(makeSel, 'Select Make');
      reset(modelSel, 'Select Model');
      confirmBtn.disabled = true;

      modal.style.display = '';
      document.body.style.overflow = 'hidden';
      yearSel.focus();
    }

    function close() {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }

    /* ── Cascade: Year → Make ── */
    yearSel.addEventListener('change', function () {
      reset(makeSel, 'Select Make');
      reset(modelSel, 'Select Model');
      confirmBtn.disabled = true;
      if (!yearSel.value) return;
      populate(makeSel, ymm.getMakesForYear(yearSel.value), 'Select Make');
    });

    /* ── Cascade: Make → Model ── */
    makeSel.addEventListener('change', function () {
      reset(modelSel, 'Select Model');
      confirmBtn.disabled = true;
      if (!makeSel.value) return;
      populate(modelSel, ymm.getModelsForYearMake(yearSel.value, makeSel.value), 'Select Model');
    });

    /* ── Model → Enable confirm ── */
    modelSel.addEventListener('change', function () {
      confirmBtn.disabled = !modelSel.value;
    });

    /* ── Confirm: save + reload ── */
    confirmBtn.addEventListener('click', function () {
      var year = yearSel.value;
      var makeKey = makeSel.value;
      var modelKey = modelSel.value;
      if (!year || !makeKey || !modelKey) return;

      var makeLabel = ymm.data.makes[makeKey].label;
      var modelLabel = ymm.data.makes[makeKey].models[modelKey].label;

      var data = {
        year: year,
        make: makeKey,
        model: modelKey,
        slug: year + '-' + makeKey + '-' + modelKey,
        label: year + ' ' + makeLabel + ' ' + modelLabel
      };

      localStorage.setItem('fiberwerx-vehicle', JSON.stringify(data));
      location.reload();
    });

    /* ── Close handlers ── */
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.style.display !== 'none') {
        close();
      }
    });

    /* ── Expose open function for fitment-status.js ── */
    window.openFitmentModal = open;
  }

  init();
})();
